import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import API from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Shield, DollarSign, Calendar, Loader2, Heart } from "lucide-react";

export default function PublicPolicyPage() {
    const { handle } = useParams();
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        API.get(`/u/${handle}`).then(r => setPolicy(r.data)).catch(() => setError("Policy not found")).finally(() => setLoading(false));
    }, [handle]);

    if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#050505]"><Loader2 className="h-8 w-8 animate-spin text-[#047857]" /></div>;
    if (error) return (
        <div className="min-h-screen flex items-center justify-center bg-[#050505] text-center">
            <div><h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Not found</h1><p className="text-[#9CA3AF]">This policy page doesn't exist.</p><Link to="/" className="text-[#047857] hover:underline text-sm mt-4 block">Back to Irish Goodbye</Link></div>
        </div>
    );

    return (
        <div className="min-h-screen-safe bg-[#050505] flex items-center justify-center px-6 py-16">
            <Card className="bg-[#0a0a0a] border-white/10 max-w-md w-full" data-testid="policy-card">
                <CardContent className="p-8 text-center space-y-6">
                    {policy.picture && <img src={policy.picture} alt="" className="w-20 h-20 rounded-full mx-auto border-2 border-[#047857]/30" />}
                    <div>
                        <h1 className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>{policy.name}</h1>
                        <p className="text-sm text-[#6B7280] mt-1">@{policy.handle}</p>
                    </div>

                    <div className="space-y-4 pt-4">
                        <div className="flex items-center justify-between p-4 rounded-lg bg-black/30 border border-white/5">
                            <div className="flex items-center gap-3"><DollarSign className="h-5 w-5 text-[#D4AF37]" /><span className="text-sm">Reply Price</span></div>
                            <span className="text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>${policy.reply_price}</span>
                        </div>
                        <div className="flex items-center justify-between p-4 rounded-lg bg-black/30 border border-white/5">
                            <div className="flex items-center gap-3"><Calendar className="h-5 w-5 text-[#047857]" /><span className="text-sm">Meeting (15 min)</span></div>
                            <span className="text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>${policy.meeting_price}</span>
                        </div>
                        {policy.charity_mode && (
                            <div className="flex items-center gap-2 text-sm text-[#9CA3AF]">
                                <Heart className="h-4 w-4 text-red-400" />
                                <span>Payments go to: {policy.charity_name || "Charity"}</span>
                            </div>
                        )}
                    </div>

                    <p className="text-xs text-[#6B7280] pt-4">
                        Powered by <Link to="/" className="text-[#047857] hover:underline">The Irish Goodbye</Link>
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
